module.exports = __webpack_public_path__ + "img/7.b4d7014a.jpg";